import { gql } from "@apollo/client";

export const CHECK_USER_AUTHENTICATED = gql`
  query getUserByToken {
    getUserByToken {
      accountingFirms
      companies
      isActive
      userCategory {
        id
        name
        slug
      }
      isSuperuser
      id
      firstName
      lastName
      email
      username
      permissions
      language
    }
  }
`;
